/* eslint-disable import/named */
import { call, put, takeEvery } from "redux-saga/effects";
import * as types from "../../constants";

import * as Services from "./service";

function* getListLogCampaign(req) {
  try {
    const response = yield call(Services.getListLogCampaign, req.payload);
    yield put({ type: "RESULT_GET_LIST_LOGS_CAMPAIGN", data: response });
  } catch (error) {
    yield put({ type: "RESULT_GET_LIST_LOGS_CAMPAIGN", error });
  }
}

function* getDataCountViewSaga() {
  try {
    const response = yield call(Services.getDataCountViewService);
    yield put({ type: "RESULT_GET_DATA_COUNT_VIEW", data: response });
  } catch (error) {
    yield put({ type: "RESULT_GET_DATA_COUNT_VIEW", error });
  }
}

function* getStaticCharSaga(req) {
  try {
    const response = yield call(Services.getStaticCharService, req.payload);
    yield put({ type: "GET_STATIC_CHAR_RESULT", data: response });
  } catch (error) {
    yield put({ type: "GET_STATIC_CHAR_RESULT", error });
  }
}

function* sagaActions() {
  yield takeEvery(types.CALL_GET_LIST_LOGS_CAMPAIGN, getListLogCampaign);
  yield takeEvery(types.GET_DATA_COUNT_VIEW, getDataCountViewSaga);
  yield takeEvery(types.GET_STATIC_CHAR, getStaticCharSaga);
}

export default sagaActions;
